"use client";

import { cn } from "@/lib/utils";
import { Info } from "lucide-react";
import * as React from "react";
import { Popover } from "components/ui/v2/popover";

type HelpAccent = "neutral" | "violet" | "sky" | "amber";

const accentHover: Record<HelpAccent, string> = {
  neutral:
    "hover:text-muted-foreground hover:bg-muted/50",
  violet:
    "hover:text-violet-500/80 hover:bg-violet-50/40 dark:hover:text-violet-400/70 dark:hover:bg-violet-950/20",
  sky:
    "hover:text-sky-500/80 hover:bg-sky-50/40 dark:hover:text-sky-400/70 dark:hover:bg-sky-950/20",
  amber:
    "hover:text-amber-500/80 hover:bg-amber-50/40 dark:hover:text-amber-400/70 dark:hover:bg-amber-950/20",
};

export interface ComposeHelpTriggerProps {
  label: string;
  speaker: React.ReactNode;
  placement?: "top" | "bottom" | "left" | "right" | "topStart" | "topEnd" | "bottomStart" | "bottomEnd";
  accent?: HelpAccent;
  className?: string;
}

/** Botón de ayuda compacto con panel v2 (sin rsuite Whisper). */
export function ComposeHelpTrigger({
  label,
  speaker,
  placement = "top",
  accent = "neutral",
  className,
}: ComposeHelpTriggerProps) {
  const side =
    placement.startsWith("bottom") ? "bottom" : "top";

  return (
    <Popover
      side={side}
      align="start"
      className="max-w-[min(92vw,32rem)] p-3"
      trigger={
        <button
          type="button"
          aria-label={label}
          className={cn(
            "inline-flex items-center gap-1 rounded-md px-0.5 py-0.5",
            "text-muted-foreground/70 transition-colors",
            accentHover[accent],
            className
          )}
        >
          <Info className="h-3 w-3 shrink-0 opacity-60" strokeWidth={2} aria-hidden />
          <span className="text-[10px] font-medium leading-none tracking-tight opacity-75">
            {label}
          </span>
        </button>
      }
    >
      {speaker}
    </Popover>
  );
}
